import api from "./api";

// First-login tour + "Erste Schritte" checklist. State lives on the user
// account (`user.onboarding`, backend/routers/auth.py); this file holds the
// step list and the events pages use to talk to AppShell without importing it.

export const TASKS = ["alert", "watchlist", "cockpit", "ai"];

// What an account created before the tour existed looks like (the backend
// sends the same default, this covers an older backend during a deploy).
const LEGACY = { tour: "done", checklist: false, tasks: [], help_seen: false };

export function onboardingOf(user) {
  return { ...LEGACY, ...(user?.onboarding || {}) };
}

// The later-banner on the dashboard stays for this long after "Später".
export const LATER_BANNER_DAYS = 7;

export function laterBannerVisible(ob, now = Date.now()) {
  if (ob.tour !== "later") return false;
  const at = Date.parse(ob.later_at || "");
  if (Number.isNaN(at)) return true;
  return now - at < LATER_BANNER_DAYS * 24 * 3600 * 1000;
}

export function checklistVisible(ob) {
  return ob.checklist === true && ob.tour !== "pending";
}

// Each step names the page it runs on and the element it points at (a
// data-testid). A step whose element is missing (no data yet, hidden on a
// phone) shows its card in the middle of the screen instead.
// `features` are nav keys from App.js's FeatureGated: if the admin hid one of
// them for this account, the step is left out rather than leading to a page
// the user cannot open. `needsListing` steps run on the best GREEN listing and
// are left out when there is none.
export const STEPS = [
  { key: "status", route: "/", target: "topbar-status" },
  { key: "faktor", route: "/", target: "dashboard-stats" },
  { key: "deals", route: "/", target: "dashboard-top-deals" },
  { key: "listings", route: "/listings", target: "listings-filters", features: ["listings"] },
  { key: "detail", route: "/listings/:id", target: "listing-kpis", features: ["listings"], needsListing: true },
  { key: "cockpit", route: "/listings/:id", target: "open-objekt-cockpit", features: ["listings", "underwriter"], needsListing: true },
  { key: "alerts", route: "/alerts", target: "new-search-btn", features: ["alerts"] },
  { key: "ai", route: null, target: "open-ai-chat" },
];

export function stepsFor(user, listingId) {
  const hidden = user?.role === "admin" ? [] : (user?.hidden_features || []);
  return STEPS
    .filter((s) => !(s.features || []).some((f) => hidden.includes(f)))
    .filter((s) => !s.needsListing || listingId)
    .map((s) => ({ ...s, route: s.route && s.route.replace(":id", encodeURIComponent(listingId || "")) }));
}

// The lowest-Faktor GREEN listing, for the detail and cockpit steps.
export async function findTourListingId() {
  try {
    // GET /listings returns rows sorted by Faktor, lowest first.
    const { data } = await api.get("/listings?zone=GREEN&limit=1");
    return data?.listings?.[0]?.id ?? null;
  } catch {
    return null;
  }
}

// Pages call this when the user did one of the checklist actions; AppShell
// listens and saves it. Fire-and-forget: a lost tick never blocks the action.
export const TASK_EVENT = "immo:onboarding-task";
export const START_EVENT = "immo:onboarding-start";
export const OPEN_AI_EVENT = "immo:open-ai-chat";

export function markOnboardingTask(task) {
  if (!TASKS.includes(task)) return;
  window.dispatchEvent(new CustomEvent(TASK_EVENT, { detail: task }));
}

export function startOnboardingTour() {
  window.dispatchEvent(new CustomEvent(START_EVENT));
}
